(function () {
    "use strict";
    
    function function_() {
        const style = document.createElement("style");
        style.textContent = `
                .hide-shopify-chat {
                    display: none !important;
                }
                .show-shopify-chat {
                    display: block !important;
                }
            `;
        document.head.append(style);

      function handleShopifyChat() {
        const shopifyChat = document.querySelector('#shopify-chat');
      
        if (shopifyChat) {
            if (window.location.pathname === '/') {
            shopifyChat.classList.add('show-shopify-chat');
            } else {
            shopifyChat.classList.add('hide-shopify-chat');
            }
        }
      }

      // Use MutationObserver to detect when the Shopify chat widget is added
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length > 0) {
            handleShopifyChat();
          }
        });
      });
    
      // Observe changes in the body
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    
      // Run the function initially in case the widget is already loaded
      handleShopifyChat();
      
    }
      
    function onDOMContentLoaded() {
    function_();
    }
    
    if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
    once: true,
    });
    } else {
    onDOMContentLoaded();
      }
})();